import { render, staticRenderFns } from "./GroupFormSidebar.vue?vue&type=template&id=c633e58e"
import script from "./GroupFormSidebar.vue?vue&type=script&lang=js"
export * from "./GroupFormSidebar.vue?vue&type=script&lang=js"
import style0 from "./GroupFormSidebar.vue?vue&type=style&index=0&id=c633e58e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports